import * as config from 'config';
import { DiamUserResponse } from 'models/user';
import { apiFetch, createQueryUrl, defaultHeaders } from 'utils/fetchUtils';

export function loginRedirect(
  languageCode: string,
  email?: string | null,
  resetSession = false
): void {
  const redirectUri = `${config.backendApi}/oauth2/authorization-code`;
  const url = createQueryUrl(`${config.authUrl}/oauth2/authorize`, {
    client_id: config.authClientId,
    redirect_uri: redirectUri,
    language: languageCode,
    username: email,
    'reset-session': resetSession ? 'true' : undefined
  });

  window.location.assign(url);
}

export async function getUserInfo(): Promise<DiamUserResponse> {
  const url = `${config.backendApi}/oauth2/user-info`;

  const res = await apiFetch<DiamUserResponse>(url, {
    headers: defaultHeaders
  });

  return res;
}

export async function logout(): Promise<void> {
  const url = `${config.backendApi}/oauth2/logout`;

  await apiFetch<void>(url, {
    headers: defaultHeaders,
    method: 'POST'
  });
}

export async function refreshToken(): Promise<boolean> {
  const url = `${config.backendApi}/oauth2/refresh-token`;

  const res = await fetch(url, {
    credentials: 'include',
    headers: defaultHeaders
  });

  return res.ok;
}
